(function() {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      var el = entry.target;
      var rect = entry.boundingClientRect;
      var vh = window.innerHeight;
      var trulyPast = rect.bottom < -10 || rect.top > vh + 10;

      if (entry.isIntersecting) {
        el.classList.add('is-visible');

        if (el.dataset.animateStagger) {
          var stagger = parseInt(el.dataset.animateStagger, 10) || 80;
          var children = el.children;
          for (var i = 0; i < children.length; i++) {
            (function(idx) {
              setTimeout(function() {
                children[idx].classList.add('is-visible');
              }, idx * stagger);
            })(i);
          }
        }
      } else if (trulyPast) {
        el.classList.remove('is-visible');
        if (el.dataset.animateStagger) {
          var children = el.children;
          for (var i = 0; i < children.length; i++) {
            children[i].classList.remove('is-visible');
          }
        }
      }
    });
  }, { threshold: 0 });

  var els = document.querySelectorAll('[data-animate], [data-animate-stagger]');
  for (var i = 0; i < els.length; i++) {
    observer.observe(els[i]);
  }
})();
